import ThermostatsPortfolio from '@/Core.Service.Domain/Controls/Thermostats/Views';
import ThermostatScheduleListView from '@/Core.Service.Domain/Controls/Thermostats/Views/ThermostatScheduleListView.vue';
import ThermostatScheduleSettingsView from '@/Core.Service.Domain/Controls/Thermostats/Views/ThermostatScheduleSettingsView.vue';

export const ThermostatsRoute = {
  path: 'thermostats',
  name: 'Thermostats',
  component: ThermostatsPortfolio,
  children: [
    {
      path: 'history/:id',
      name: 'ThermostatHistory',
    },
  ],
  meta: {
    placeholder: 'Search for a Thermostat',
    controlTypeName: 'Thermostat',
    controlTypeId: 2,
    label: 'Thermostats',
    toolTip: 'Thermostat',
    requiresSiteProperty: 'hasThermostat',
  },
};

export const ThermostatSchedulesRoute = {
  path: 'thermostats/schedules',
  name: 'ThermostatSchedules',
  component: ThermostatScheduleListView,
  meta: {
    placeholder: 'Search for a Thermostat',
    controlTypeName: 'Thermostat',
    controlTypeId: 2,
    label: 'Thermostat Scheduling',
    toolTip: 'Thermostat',
  },
};

export const ThermostatScheduleSettingsRoute = {
  path: 'thermostats/schedules/:thermostatId',
  name: 'ThermostatScheduleSettings',
  component: ThermostatScheduleSettingsView,
  meta: {
    placeholder: 'Search for a Thermostat',
    controlTypeName: 'Thermostat',
    controlTypeId: 2,
    label: 'Schedule Settings',
    toolTip: 'Thermostat',
  },
};
